import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from 'reactstrap';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import './SecuritySettings.css';
import TwoFASettingsModal from './twoFASettingsModal/TwoFASettingsModal.container';
import IconContainer from './../../commonComponents/iconContainer/IconContainer';

class SecuritySettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            is2FAEnable: false
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.is2FAEnable) && this.state.is2FAEnable !== nextProps.is2FAEnable && !nextProps.loading) {
            this.setState({ is2FAEnable: nextProps.is2FAEnable });
        }
    }

    render() {
        return (
            <div className="security-settings-container">
                <h5 className="text-center security-settings-label">{_.get(this.props.translation, 'security_settings.2fa_label')}</h5>
                {this.renderContent()}
                <TwoFASettingsModal />
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && _.isNil(this.props.is2FAEnable)) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
            )
        }

        return (
            <div>
                <div className="two-fa-status-container">
                    <span className="status-label">
                        {_.get(this.props.translation, 'security_settings.current_status_label')}
                    </span>
                    <div className="two-fa-status-with-icon-container">
                        <IconContainer
                            className={"two-fa-status-icon " + (this.props.is2FAEnable ? "enabled" : "disabled")}
                            icon={this.props.is2FAEnable ? "check_circle_outline" : "highlight_off"}
                        />
                        {_.get(this.props.translation, 'security_settings.' + (this.props.is2FAEnable ? "2fa_enabled_label" : "2fa_disabled_label"))}
                    </div>
                </div>
                <div className="button-container">
                    <Button className="olive-green-btn" type="submit" onClick={this.props.onSubmit}>
                        {_.get(this.props.translation, 'security_settings.' + (this.props.is2FAEnable ? "disable_2fa_submit_button" : "enable_2fa_submit_button"))}
                    </Button>
                </div>
            </div>
        );
    };
}

SecuritySettings.propTypes = {
    is2FAEnable: PropTypes.bool,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onMount: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default SecuritySettings;



// WEBPACK FOOTER //
// ./src/components/accountManagement/securitySettings/SecuritySettings.js